import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import thirdPartyType from 'src/assets/Buy_Policy_Images/thirdPartyType.svg'
import comprehensiveType from 'src/assets/Buy_Policy_Images/comprehensiveType.svg'
import ownDamageType from 'src/assets/Buy_Policy_Images/ownDamageType.svg'
import { Box } from '@mui/material'

const BikeInsuranceType = () => {
  const classes = useStyles()

  const [thirdPartyReadMore, setThirdPartyReadMore] = useState(false)
  const [comprehensiveReadMore, setComprehensiveReadMore] = useState(false)
  const [ownDamageReadMore, setOwnDamageReadMore] = useState(false)

  return (
    <Box className={classes.insuranceTypeContainer}>
      <Box className={classes.insuranceTypeTitle}>
        Types Of Bike Insurances?
      </Box>
      <Box className={classes.insuranceTypeRow}>
        <Box className={classes.thirdPartyType}>
          <Box className={classes.thirdPartyTitle}>Third-Party</Box>
          <Box className={classes.thirdPartySubheadingText}>
            Covers damage to <b>others only</b>
          </Box>
          <Box>
            <img
              src={thirdPartyType}
              alt='thirdPartyImage'
              className={classes.insuranceImages}
            />
          </Box>
          <Box className={classes.insuranceTypeText}>
            According to the Motor Vehicles Act, of 1988, third-party insurance
            is a must for all vehicles in India. It&apos;s easy to grasp -
            &nbsp;
            <b>
              it means if our vehicle causes harm to someone else&apos;s
              vehicle, or property, or injures or even causes death to someone,
              this insurance covers the costs
            </b>
            .
          </Box>
          {thirdPartyReadMore && (
            <Box className={classes.insuranceTypeText}>
              It pays for damage to their property and medical bills, up to Rs.
              7.5 lakhs. If someone unfortunately dies in the accident, this
              insurance helps compensate their family based on what the court
              decides is fair.
            </Box>
          )}
          <Box
            id='readMoreText'
            className={classes.readMoreText}
            onClick={() => {
              setThirdPartyReadMore(!thirdPartyReadMore)
            }}
          >
            {thirdPartyReadMore ? <p>readless...</p> : <p>readmore...</p>}
          </Box>
        </Box>
        <Box className={classes.comprehensiveType}>
          <Box className={classes.comprehensiveTitle}>Comprehensive</Box>
          <Box className={classes.comprehensiveSubheadingText}>
            Covers <b>both</b> you and others
          </Box>
          <Box>
            <img
              src={comprehensiveType}
              alt='comprehensiveImage'
              className={classes.insuranceImages}
            />
          </Box>
          <Box className={classes.insuranceTypeText}>
            The name says it all - Comprehensive Bike Insurance gives you
            complete protection. While third-party insurance only covers harm to
            others, comprehensive plans cover both third-party liability and
            damage to your own vehicle.
          </Box>
          {comprehensiveReadMore && (
            <Box className={classes.insuranceTypeText}>
              This means it protects you in case of an accident or natural
              disaster, ensuring
              <b>
                {' '}
                you&apos;re covered for damage to your bike and any harm caused
                to others.
              </b>
            </Box>
          )}
          <Box
            className={classes.readMoreText}
            onClick={() => {
              setComprehensiveReadMore(!comprehensiveReadMore)
            }}
          >
            {comprehensiveReadMore ? <p>readless...</p> : <p>readmore...</p>}
          </Box>
        </Box>
        <Box className={classes.ownDamageType}>
          <Box className={classes.ownDamageTitle}>Own Damage</Box>
          <Box className={classes.ownDamageSubheadingText}>
            Should be chosen
            <br /> <b>if Third-Party is active</b>
          </Box>
          <Box>
            <img
              src={ownDamageType}
              alt='ownDamageImage'
              className={classes.insuranceImages}
            />
          </Box>
          <Box className={classes.insuranceTypeText}>
            Own damage insurance is just like comprehensive insurance, covering
            both damage to your vehicle and liability towards others. You might
            wonder why it&apos;s discussed separately.
          </Box>
          {ownDamageReadMore && (
            <Box className={classes.insuranceTypeText}>
              {' '}
              <b>Here&apos;s the easy explanation:</b> It&apos;s a must to have
              third-party insurance for your bike as per the Motor Vehicles Act,
              1988. To fully protect your vehicle, you should go for
              comprehensive insurance. However, to ensure all bike owners are
              insured, starting in 2018, new vehicles need to get a 5-year
              third-party insurance & 1-year own damage insurance when
              purchasing a new vehicle. Once that first year is over,
              you&apos;ll renew the own damage insurance each year.
            </Box>
          )}
          <Box
            className={classes.readMoreText}
            onClick={() => {
              setOwnDamageReadMore(!ownDamageReadMore)
            }}
          >
            {ownDamageReadMore ? <p>readless...</p> : <p>readmore...</p>}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BikeInsuranceType

const useStyles = makeStyles({
  insuranceTypeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    backgroundColor: '#FFFFFF',
    paddingTop: 6,
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 50,
    fontFamily: 'Roboto',
  },
  insuranceTypeTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600px',
    fontSize: '28px',
  },
  insuranceTypeRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    justifyContent: 'space-between',
    '@media (max-width:1024px)': {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 10,
      gap: 20,
    },
  },
  thirdPartyType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '300px',
    maxHeight: '750px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #EF669B -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  comprehensiveType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '300px',
    maxHeight: '750px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #4DC3E3 -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  ownDamageType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '300px',
    maxHeight: '750px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #9271BE -80.32%, rgba(255, 255, 255, 0) 60.09%)',
  },
  thirdPartyTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#E25B8F',
  },
  comprehensiveTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#3092AD',
  },
  ownDamageTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#8561B5',
  },
  thirdPartySubheadingText: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#EF669B',
    padding: '20px',
    margin: '10px',
    color: '#972853',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  comprehensiveSubheadingText: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#4DC3E3',
    padding: '20px',
    margin: '10px',
    color: '#23687B',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  ownDamageSubheadingText: {
    textAlign: 'center',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#9271BE',
    padding: '13px 20px',
    margin: '10px',
    color: '#734AAA',
    fontSize: '14px',
    width: '200px',
    maxHeight: '60px',
  },
  insuranceTypeText: {
    fontSize: '16px',
    lineHeight: '21px',
    padding: '10px 0px',
  },
  insuranceImages: {
    padding: '10px',
  },
  readMoreText: {
    marginRight: 'auto',
    color: '#1A90B0',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
})
